import {POST, GET, DELETE} from "@/services/gateway";

const listExport = ({pagination, sourceType, dataTypes, dataProvider = 'MICROSOFT'}) => {
  return POST('recovery/export/entra-list', {pagination, sourceType, dataTypes, dataProvider})
}

const deleteExport = (id) => {
  return DELETE(`recovery/export`, id)
}

const downloadExport = (id) => {
  return GET(`recovery/export/${id}/entra-id/download`)
}

const cancelExport = (id) => {
  return GET(`entra-id/export/${id}/cancel`)
}

export {
  listExport,
  downloadExport,
  deleteExport,
  cancelExport,
}
